<template><section>
<h1>Pagination</h1>
<p>Documentation and examples for showing pagination to indicate a series of related content exists across multiple pages.</p>
<demo clz="">
                    <bs-pagination :pages="3" show-first="" show-last=""></bs-pagination>

                    <template slot="desp"><p>Examle</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">show-first</span> <span class="hljs-attr">show-last</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
</code></pre>
</template></demo>
<demo clz="">
                    <bs-pagination :pages="3" show-first="" show-last="">
  <template slot="first">
    <span aria-hidden="true">&laquo;</span>
    <span class="sr-only">Previous</span>
  </template>
  <template slot="prev">
    <span aria-hidden="true">&lt;</span>
    <span class="sr-only">Previous</span>
  </template>
  <template slot="next">
    <span aria-hidden="true">&gt;</span>
    <span class="sr-only">Next</span>
  </template>
  <template slot="last">
    <span aria-hidden="true">&raquo;</span>
    <span class="sr-only">Next</span>
  </template>
</bs-pagination>

                    <template slot="desp"><p>Working with icons</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">show-first</span> <span class="hljs-attr">show-last</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"first"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">aria-hidden</span>=<span class="hljs-string">"true"</span>&gt;</span>&amp;laquo;<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"sr-only"</span>&gt;</span>Previous<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"prev"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">aria-hidden</span>=<span class="hljs-string">"true"</span>&gt;</span>&amp;lt;<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"sr-only"</span>&gt;</span>Previous<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"next"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">aria-hidden</span>=<span class="hljs-string">"true"</span>&gt;</span>&amp;gt;<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"sr-only"</span>&gt;</span>Next<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"last"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">aria-hidden</span>=<span class="hljs-string">"true"</span>&gt;</span>&amp;raquo;<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"sr-only"</span>&gt;</span>Next<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
</code></pre>
</template></demo>
<demo clz="">
                    <bs-pagination :pages="3" v-model="pagination1" show-first="" show-last=""></bs-pagination>

                    <template slot="desp"><p>Disabled and active states</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"pagination1"</span> <span class="hljs-attr">show-first</span> <span class="hljs-attr">show-last</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
</code></pre>
</template></demo>
<demo clz="">
                    <bs-pagination :pages="20" v-model="pagination2" :limit="9"></bs-pagination>

                    <template slot="desp"><p>With many pages</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"20"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"pagination2"</span> <span class="hljs-attr">:limit</span>=<span class="hljs-string">"9"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
</code></pre>
</template></demo>
<demo clz="">
                    <bs-pagination :pages="3" size="lg"></bs-pagination>
<bs-pagination :pages="3" size="sm"></bs-pagination>

                    <template slot="desp"><p>Sizing</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"lg"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"sm"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
</code></pre>
</template></demo>
<demo clz="">
                    <bs-pagination desc="Page navigation example" :pages="3" align="center"></bs-pagination>
<bs-pagination desc="Page navigation example" :pages="3" align="end"></bs-pagination>

                    <template slot="desp"><p>Alignment</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">desc</span>=<span class="hljs-string">"Page navigation example"</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">align</span>=<span class="hljs-string">"center"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">bs-pagination</span> <span class="hljs-attr">desc</span>=<span class="hljs-string">"Page navigation example"</span> <span class="hljs-attr">:pages</span>=<span class="hljs-string">"3"</span> <span class="hljs-attr">align</span>=<span class="hljs-string">"end"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">bs-pagination</span>&gt;</span>
</code></pre>
</template></demo>
</section></template>

<script>
export default {
  data () {
    return {
      pagination1: 3,
      pagination2: 5
    }
  }
}
</script>


// WEBPACK FOOTER //
// example/views/components/Pagination.vue?0ca30dae